<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">日本におけるプライベート・エクイティ：最悪の事態？
</h1>	

                <span class="meta"> Posted in September 2022 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/privateequityjapan_bw.png" alt="">
                </figure>
                
<p>私はVC業界の人間でありPE業界の人間ではないので、プライベート・エクイティについて論評する場合、読者は私の言葉を冷静に受け止めてくれるはずである。私は、日本の現場で、ある現象を観察しており、それを共有することが重要だと考えている。</p>


<p>まず、現在のマクロ経済の背景について、多くの専門家（専門家と実務家の両方）が意見を述べている。ほとんどの先進国では、大規模なインフレが進行しており、米国のインフレ率のコア指標である消費者物価指数（CPI）は最終的に8.6%に上昇した。</p>

<p>政府、特にインフレ抑制を主要な任務とする中央銀行は、気がつけば時代に取り残されていた。その結果、米国連邦準備銀行、それに続く欧州中央銀行とイングランド銀行は、利上げと量的引き締めを継続的に行い、資産価格を急落させることになった。</p>

<p>G7 諸国で例外的な状況にあるのは、日本だけである。どの程度の幅のバスケットを使うかにもよるが、日本のCPIインフレ率はわずか2.5%しか上昇せず、計算から食品とエネルギーを取り除くと、インフレ率は現在わずか0.3%であり、米国の同等の指標よりも20倍も低い。</p>

<p>そのため、日銀はイールドカーブ・コントロール政策を維持し、10年物国債の利回りを事実上25bpに抑えている。日本が低金利を維持する一方で諸外国が利上げや引き締めを行う、この激しい格差の影響は、以前にも書いたように、20年ぶりの安値となる急激な円安として現れている。 </p>

<p>円相場の下落を受け、市場では日銀が自国通貨を買い支えるためにイールドカーブ・コントロールを緩めるのではないかという憶測が流れている。しかし、東京のコンセンサスは、日本のインフレが手に負えなくならない限り、日銀はこの方針を維持する以外にないだろう、というものである。しかも、日銀の黒田総裁は来春に最後の任期を迎える。黒田総裁の最後の9カ月間に急激な政策転換が行われる可能性は低いと思われる。</p>

<p>ここで、プライベート・エクイティの話に戻ろう。  プライベート・エクイティ取引が成功した場合、最大3つの方法で価値を生み出すことができる（VCは3つしかないと冗談を言いますが、ここでは我慢することとする。）。 </p>


<p>1.	経営効率化</p>


<p>2.	マルチプル・エクスパンション</p>


<p>3.	レバレッジ</p>


<p>リストラクチャリングにより、経営効率を上げることができる。不採算資産の売却、コスト削減、買収、経営陣のインセンティブの調整などは、PEファームが経営権を取得した後に企業にもたらすことができる方法の一つである。</p>

<p>マルチプル・エクスパンションとは、EV/SやEV/EBITDA（それぞれ企業価値/売上高、企業価値/EBITDA）のマルチプルがより高くなるように企業を変革することである。より高いマルチプルは、戦略的フォーカスの強化、コーポレートガバナンスの改善などの内部的要因と、成長または人気が回復しつつあるセクターへの投資などの外部的要因の両方によって達成することができる。</p>

<p>レバレッジとは、PEバイアウトでターゲット企業を買収するために、かなりの部分を借入金で賄うことを意味する。例えば、1億ドルの企業買収の場合、典型的なレバレッジド・バイアウトでは、PEファンドから3000万ドルの株式、貸し手から7000万ドルの借入金が必要とされるかもしれない。</p>

<p>ご想像の通り、上記の2つまたは3つ全ての要素を組み合わせることで、投資リターンのプロファイルを飛躍的に向上させることができる。例えば、前述の1億ドルの企業がEBITDAの5倍で評価されているとしよう（EBITDA = 1億 / 5 =>2千万）。この取引は、PEファンドから3,000万円、外部から7,000万円の借入金でおこわなれたとする。もしPEファンドが業務効率化によってEBITDAを2,000万ドルから3,000万ドルに増加させ、同時に戦略的集中とセクターの成長によって、この会社のEV/EBITDA倍率が5倍ではなく、7倍に正当化できた場合、この会社の企業価値は2億1千万ドルとなる。この価格で買い手を見つけることができれば、PEファンドは4.67倍（(2億1000万-7000万負債)/3000万）の投資資本利益率を得ることができるのである。 </p>

<p>上記のプライベート・エクイティの価値創造の3つの要素から日本を見ると、日本の市場は非常に魅力的に見える。 </p>

<p>名前を挙げるまでもなく、多くの既存企業が不採算事業を抱えていることは周知の事実であり、それゆえに事業再編の機会があり、その結果、経営効率を上げることができるかもしれない。さらに、日本の新しいESGコンプライアンス要件により、一部の企業は事業再編を余儀なくされ、場合によっては事業部門を切り離すことがあるかもしれない。</p>

<p>マルチプル・エクスパンションの原理では、金利上昇で資産価格が下落し、EV/EBITDA倍率は世界的に全く逆の方向に動いている。欧米では日本以上にマルチプル・エクスパンションの圧縮の力が働いている。</p>

<p>しかし、低金利環境のおかげで、日本のデット・ファイナンスは世界の他の国々と比べて相対的に割安であり続けている。安価なレバレッジでバイアウト案件を組成することができる日本は、プライベート・エクイティの価値創造の観点からは、非常に魅力的である。</p>

<p>さらに、日本におけるプライベート・エクイティビジネスに対する認識は、外資系ファンドであっても徐々に改善されつつある。海外のPEファンドの目には、日本市場は、信頼できる法の下、安全なものとして映っているのだ。</p>

<p>表面的な分析に過ぎないが、現在の環境において、日本はグローバルPEファンドにとって魅力的な市場であることは明らかである。</p>

<p>その兆候は既に現れている。今回の株主総会シーズンでは、過去最高の77社が株主からの提案を受け、その多くが外資系ファンドによるものだった。3月にはスウェーデンのEQTがBering Private Equity Asiaを買収し、日本での事業拡大を明言した。東芝の200億ドル規模の買収が目前に迫っており、その動向が注目される。 </p>

<p>これらのデータがより大きなトレンドとなるかどうかはまだ分からないが、もしそうであれば、日本国内のPEファームにとって競争が激化する可能性がある。(シンジケートで共同投資することが多いVCと違って、プライベート・エクイティはどちらかというと単独で投資することが多い)。非公式に聞いたことによると、彼らは警戒していないようだ。</p>

<p>これは私の分野からかけ離れているかもしれないが、私はこのような仮説的な思考を試すことを楽しんでいるので、以下に日本国内のPEファームに対する私の勝手な（おそらく歓迎されないであろう）アドバイスを述べる。日本のベンチャーキャピタルファンドのようなアップストリームの関係を構築することである。日本のベンチャーキャピタルは、外国人にとって不透明な市場であり、現地にいる方が有利である。全てのベンチャー企業がプライベート・エクイティのターゲットになるわけではないが、エンタープライズSaaSのような高成長企業など、PEによるビルドアップ戦略の補完的なターゲットとなるセクターはよくある。このような関係を構築することで、競争が激化した入札が始まる前に将来のディールフローのための土台を築くことができるのである。</p>






              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>

